/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { getBackgroundImageSrc } from '../../../services/asset';
import { IndexCarousel } from '../../IndexCarousel';
import styles from './CoverImage.scss';
import { Icon } from 'antd';

export interface ICoverImage {
  ad: any;
  isMobile: boolean;
  eventLabel?: string;
}

const carouselSettings = {
  autoplay: false,
  arrows: true,
  dots: false,
  fade: true,
  infinite: true,
  lazyLoad: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: true,
  nextArrow: <Icon type="right" />,
  prevArrow: <Icon type="left" />
};

const CoverImage = (props: ICoverImage) => {
  const { ad, isMobile, eventLabel } = props;

  const hasCoverImage = useMemo(() => {
    return (ad.images && ad.images.length > 0) || (ad.videoUrl && ad.videoUrl.length > 0);
  }, [ad]);

  return (
    <span
      className={`image ${isMobile ? styles.imageMobile : styles.image}`}
      style={hasCoverImage ? null : getBackgroundImageSrc()}
    >
      {hasCoverImage ? (
        <IndexCarousel
          images={ad.images}
          settings={carouselSettings}
          imageClassName={
            isMobile
              ? styles.carouselImageClassNameMobile
              : styles.carouselImageClassName
          }
          videoUrl={ad.videoUrl}
          eventLabel={eventLabel}
        />
      ) : null}
    </span>
  );
};

export default CoverImage;



// WEBPACK FOOTER //
// ./src/components/SimilarAdCard/CoverImage/CoverImage.tsx